import React from 'react';
import './AlertModal.css';

/**
 * AlertModal Component
 * A modal dialog for displaying alert messages
 */
const AlertModal = ({ isOpen, onClose, message }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content alert-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Alert</h3>
        </div>
        <div className="modal-body">
          <p>{message}</p>
        </div>
        <div className="modal-footer">
          <button className="modal-btn modal-btn-confirm" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;

